import { Controller } from "@hotwired/stimulus"

// Per-row edit + individual save on the Integration Access table. Rows
// render their checkboxes locked (visible, not interactive). The pencil
// puts a row into edit mode: it unlocks the checkboxes, swaps the pencil
// for Save/Cancel, and highlights the row. Save PATCHes just that row;
// Cancel restores the checkboxes to how they were.
export default class extends Controller {
  static targets = ["field", "editBtn", "saveBtn", "actions"]
  static classes = ["highlight"]
  static values = { url: String, slug: String, csrf: String }

  enable(event) {
    event?.preventDefault()
    this._snapshot = this.fieldTargets.map((f) => f.checked)
    this._setLocked(false)
    this.editBtnTarget.classList.add("hidden")
    this.actionsTarget.classList.remove("hidden")
    this.actionsTarget.classList.add("inline-flex")
    if (this.hasHighlightClass) this.element.classList.add(...this.highlightClasses)
  }

  cancel(event) {
    event?.preventDefault()
    if (this._snapshot) this.fieldTargets.forEach((f, i) => { f.checked = this._snapshot[i] })
    this._exitEdit()
  }

  async save(event) {
    event?.preventDefault()
    const roles = this.fieldTargets.filter((f) => f.checked).map((f) => f.value)
    this.saveBtnTarget.disabled = true

    try {
      const res = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": this.csrfValue
        },
        body: JSON.stringify({ provider_slug: this.slugValue, roles })
      })
      if (!res.ok) throw new Error("save failed")
      this._exitEdit()
    } catch (e) {
      alert("Couldn't save — please try again.")
    } finally {
      this.saveBtnTarget.disabled = false
    }
  }

  _exitEdit() {
    this._setLocked(true)
    this.actionsTarget.classList.add("hidden")
    this.actionsTarget.classList.remove("inline-flex")
    this.editBtnTarget.classList.remove("hidden")
    if (this.hasHighlightClass) this.element.classList.remove(...this.highlightClasses)
  }

  _setLocked(locked) {
    this.fieldTargets.forEach((f) => {
      f.classList.toggle("pointer-events-none", locked)
      f.classList.toggle("opacity-50", locked)
    })
  }
}
